'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dHash$002dMap$0024$002dAbstract$002dHash$002dMap$002dIterator from "./java.util.-Hash-Map$-Abstract-Hash-Map-Iterator.js";
var $p;
/** @constructor */
function $c_ju_HashMap$NodeIterator(outer) {
  this.vt = 0;
  this.m0 = 0;
  this.m1 = null;
  this.sa = null;
  this.s9 = null;
  $j_java$002eutil$002e$002dHash$002dMap$0024$002dAbstract$002dHash$002dMap$002dIterator.$ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer);
}
export { $c_ju_HashMap$NodeIterator as $c_ju_HashMap$NodeIterator };
$p = $c_ju_HashMap$NodeIterator.prototype = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dAbstract$002dHash$002dMap$002dIterator.$h_ju_HashMap$AbstractHashMapIterator();
$p.constructor = $c_ju_HashMap$NodeIterator;
/** @constructor */
function $h_ju_HashMap$NodeIterator() {
}
export { $h_ju_HashMap$NodeIterator as $h_ju_HashMap$NodeIterator };
$h_ju_HashMap$NodeIterator.prototype = $p;
$p.OW = (function(node) {
  return node;
});
var $d_ju_HashMap$NodeIterator = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_HashMap$NodeIterator, "java.util.HashMap$NodeIterator", ({
  n8: 1,
  dR: 1,
  bd: 1
}));
export { $d_ju_HashMap$NodeIterator as $d_ju_HashMap$NodeIterator };
